import { render, staticRenderFns } from "./PageListInvitations.vue?vue&type=template&id=6d1480c0&scoped=true"
import script from "./PageListInvitations.vue?vue&type=script&lang=js"
export * from "./PageListInvitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1480c0",
  null
  
)

export default component.exports